import React from 'react';
import { Button } from './ui/Button';
import { GlassWater, Plus } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function BundleSection() {
  return <section className="py-10 bg-cream" data-id="element-61">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-63">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-4" data-id="element-64">
            Todo lo que necesitás para tu transformación
          </h2>
          <p className="text-lg text-sage/80" data-id="element-65">
            Un sistema completo diseñado para que no tengas que pensar, solo
            aplicar y disfrutar los resultados.
          </p>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-66">
          {/* Core Product */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-sage/5 mb-8 flex flex-col md:flex-row items-center gap-10" data-id="element-67">
            <div className="w-full md:w-2/5 flex justify-center" data-id="element-68">
              <img src="https://cdn.magicpatterns.com/uploads/bNonPf28N1GYLUPsiT7ZGV/ebook.png" alt="Reto 28 Días Sin Inflamación" className="w-full max-w-sm object-contain drop-shadow-2xl" data-id="element-69" />
            </div>
            <div className="w-full md:w-3/5" data-id="element-70">
              <div className="inline-block bg-gold/20 text-gold-dark font-bold px-4 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-71">
                Programa Principal
              </div>
              <h3 className="text-3xl font-serif font-bold text-sage mb-4" data-id="element-72">
                Reto 28 Días Sin Inflamación
              </h3>
              <p className="text-sage/80 text-lg mb-6" data-id="element-73">
                El manual paso a paso para resetear tu metabolismo. Incluye la
                famosa{' '}
                <span className="font-bold text-sage" data-id="element-74">
                  "Regla de los 2 días"
                </span>{' '}
                para disfrutar de tus comidas favoritas sin retroceder en tus
                resultados.
              </p>
            </div>
          </div>

          <div className="flex justify-center mb-6" data-id="element-75">
            <div className="bg-sage text-white p-3 rounded-full shadow-lg" data-id="element-76">
              <Plus className="w-6 h-6" data-id="element-77" />
            </div>
          </div>

          {/* Accelerators */}
          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-78">
            {/* Accelerator 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-sage/5 flex flex-col items-center text-center" data-id="element-79">
              <div className="w-full mb-6 flex items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-80">
                <img src="https://cdn.magicpatterns.com/uploads/gHKZrUXFHfojZZkDHXRB6G/infusionbono.png" alt="Ritual de Infusiones" className="w-full h-auto object-contain" data-id="element-81" />
              </div>
              <div className="text-xs font-bold text-gold uppercase tracking-wider mb-2" data-id="element-82">
                Acelerador 1
              </div>
              <h4 className="text-xl font-serif font-bold text-sage mb-2" data-id="element-83">
                Ritual de Infusiones
              </h4>
              <p className="text-sage/70 text-sm italic" data-id="element-84">
                "Desinflamar 2x más rápido"
              </p>
            </div>

            {/* Accelerator 2 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-sage/5 flex flex-col items-center text-center" data-id="element-85">
              <div className="w-full mb-6 flex items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-86">
                <img src="https://cdn.magicpatterns.com/uploads/uoAoP8oMUsiX6z9hCxnznt/postresbono.png" alt="Postres Fit Sin Culpa" className="w-full h-auto object-contain" data-id="element-87" />
              </div>
              <div className="text-xs font-bold text-gold uppercase tracking-wider mb-2" data-id="element-88">
                Acelerador 2
              </div>
              <h4 className="text-xl font-serif font-bold text-sage mb-2" data-id="element-89">
                Postres Fit Sin Culpa
              </h4>
              <p className="text-sage/70 text-sm italic" data-id="element-90">
                "No es debilidad, es neurología"
              </p>
            </div>

            {/* Accelerator 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-sage/5 flex flex-col items-center text-center" data-id="element-91">
              <div className="w-full mb-6 flex items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-92">
                <img src="https://cdn.magicpatterns.com/uploads/s68RdnbgjpXVemp8uCfgyD/SMOOTHIESBONO3.png" alt="Smoothies Cero Inflamación" className="w-full h-auto object-contain" data-id="element-93" />
              </div>
              <div className="text-xs font-bold text-gold uppercase tracking-wider mb-2" data-id="element-94">
                Acelerador 3
              </div>
              <h4 className="text-xl font-serif font-bold text-sage mb-2" data-id="element-95">
                Smoothies Cero Inflamación
              </h4>
              <p className="text-sage/70 text-sm italic" data-id="element-96">
                "Logística dominical: Desayunos listos en 30 min"
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-97">
            <a href="https://www.elplacerquenutre.com//cart/44835922083942:1" onClick={e => trackAddToCart(e)} className="inline-block" data-id="element-98">
              <Button size="xl" variant="primary" className="px-12 shadow-gold/30" data-id="element-99">
                QUIERO TODO EL PAQUETE AHORA
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}